import Signers from "../../../containers/Profile/Documentation/Signers/SignersContainer";
import Documentation from "../../../containers/Profile/Documentation/EntryPointContainer";
import { RouteObject } from "../../../interfaces/navigation";

export const documentationSubRoutes: RouteObject[] = [
    {
        title: "Firmantes",
        path: "signers",
        component: <Signers/>
    }
];

export const documentationRoutes: RouteObject[] = [
    {
        title: "Documentos",
        path: "documentation",
        component: <Documentation/>,
        subRoutes: documentationSubRoutes
    }
];